import NotificationIcon from "./notification";
import SearchIcon from "./search-icon";
import SoundIcon from "./sound";
const icons = {
  notificationicon: NotificationIcon,
  searchicon: SearchIcon,
  soundicon: SoundIcon
}
export default icons;